import { ActivityType, IActivity } from '@pbl/pbl-react-core/lib/models/activity/types';
import constants from 'config/constants';
import { useCallback } from 'react';
import { useHistory } from 'react-router';

export const useNavigateToActivity = () => {
  const { push: navigate } = useHistory();

  const navigateToActivity = useCallback(
    (activity: IActivity): void => {
      if (activity.type === ActivityType.COLLECT_ALL) {
        navigate({
          pathname: `/collect-them-all/${activity.id}`,
          state: { activityKey: activity.key }
        });
      } else if (activity.type === ActivityType.STANDARD_ACTIVITY && activity.key === constants.INVITE_FRIENDS_ACTIVITY_KEY) {
        // In standard activity, when the key matches the invite-friend key in env variables only then navigate to /invite-friends
        navigate({ pathname: 'invite-friends' });
      } else if (activity.type === ActivityType.STANDARD_ACTIVITY && activity.key === constants.INVITE_ACCEPTED_ACTIVITY_KEY) {
        navigate({ pathname: 'invite-friends' });
      } else if (activity.type === ActivityType.STANDARD_ACTIVITY && activity.key === constants.COMPLETE_YOUR_PROFILE_ACTIVITY_KEY) {
        navigate({ pathname: `/profile-completion/${activity.id}` });
      } else if (activity.type === ActivityType.STANDARD_ACTIVITY && activity.key === constants.PROMOTIONS_EMAIL_OPT_IN_ACTIVITY_KEY) {
        navigate({ pathname: `/email-signUp/${activity.id}` });
      } else {
        navigate({ pathname: `/${activity.type.toLowerCase().replace('_', '-')}/${activity.id}` });
      }
    },
    [navigate]
  );

  return {
    navigateToActivity
  };
};
